module.exports = __webpack_public_path__ + "media/images/light_grey_slant-bbf72c191a89cbe102d77e50c8fe8e81.svg";